import React from "react";
import { Link } from "react-router-dom";

// T9 Fix-pack C #1 — the wordmark is a clean teal sans set in "Cognivio". No serif display face,
// no gold offset rule: the marketing flourish read as an underline glitch in-app. One shared
// component; every render site (app header, mobile bar, login card) consumes it with a size prop.
const SIZES = {
  sm: "text-lg",
  md: "text-2xl",
  lg: "text-3xl",
};

// ADMIN-A1b — `variant`: the canonical mark is teal (#0F6E6E), which fails AA (2.87:1) on the dark
// admin rail (#071a37). variant="onDark" keeps identical geometry/lettering and only swaps the fill to
// the light card token (white, 17.33:1) — the standard dark-surface logo treatment. No new lockup, no
// new color. Default is byte-identical to before, so the teacher header renders exactly as it did.
const FILL = {
  default: "text-primary",
  onDark: "text-card",
};

export function BrandWordmark({ to = "/", size = "sm", variant = "default", className = "" }) {
  const text = SIZES[size] || SIZES.sm;
  const fill = FILL[variant] || FILL.default;
  const inner = (
    <span className={`font-semibold tracking-tight ${fill} leading-none ${text}`}>Cognivio</span>
  );
  return to ? (
    // AUTH-WAY-1 (FO5) — the LINKED wordmark is a tap target, not decoration: it navigates to "/".
    // Measured 30.0px on the login card before this. `min-h-[44px]` + `items-center` gives it the
    // floor without pinning a height, so the glyph stays exactly where it was and only the
    // touchable box grows. The non-link variant below is a plain <span> and is deliberately NOT
    // floored — nothing can be tapped there, and a 44px box would push layout on every surface.
    <Link to={to} aria-label="Cognivio" data-testid="brand-wordmark" className={`inline-flex min-h-[44px] items-center no-underline ${className}`}>
      {inner}
    </Link>
  ) : (
    <span data-testid="brand-wordmark" className={`inline-flex ${className}`}>{inner}</span>
  );
}

export default BrandWordmark;
